var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgendaMobileEmptyDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 88,
    viewBox: "0 0 114 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#agenda_mobile_empty_day_clip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 113,
    height: 87,
    rx: 5.5,
    fill: "#F5F3F1",
    stroke: "#E8E1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.6863 2.68629 0 6 0H108C111.314 0 114 2.68629 114 6V12.8H0V6Z",
    fill: "#DAD1CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84 7.99962C9.70681 7.99962 10.4095 7.28328 10.4095 6.39962C10.4095 5.51597 9.70681 4.79962 8.84 4.79962C7.97319 4.79962 7.27051 5.51597 7.27051 6.39962C7.27051 7.28328 7.97319 7.99962 8.84 7.99962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0705 7.99962C14.9373 7.99962 15.64 7.28328 15.64 6.39962C15.64 5.51597 14.9373 4.79962 14.0705 4.79962C13.2037 4.79962 12.501 5.51597 12.501 6.39962C12.501 7.28328 13.2037 7.99962 14.0705 7.99962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3029 7.99962C20.1697 7.99962 20.8724 7.28328 20.8724 6.39962C20.8724 5.51597 20.1697 4.79962 19.3029 4.79962C18.4361 4.79962 17.7334 5.51597 17.7334 6.39962C17.7334 7.28328 18.4361 7.99962 19.3029 7.99962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7936 55.8017L65.7716 47.7519C64.1891 46.1639 61.8256 45.8545 59.9212 46.7963L52.6185 39.4683V35.1993L43.8497 28.6L39.4653 32.9995L46.0419 41.7987H50.2961L57.5988 49.1267C56.6671 51.0378 56.9686 53.4094 58.5511 54.9974L66.5731 63.0472C67.5733 64.0509 69.19 64.0509 70.1833 63.0472L73.7936 59.4245C74.7869 58.4208 74.7869 56.7985 73.7936 55.8017ZM62.1887 44.0672C64.1274 44.0672 65.9497 44.8234 67.3198 46.1983L68.6488 47.5319C69.7312 47.0575 70.7588 46.3976 71.6494 45.504C74.1909 42.9536 75.0541 39.3652 74.2457 36.1067C74.095 35.4881 73.3209 35.2749 72.8688 35.7287L67.7719 40.8432L63.1204 40.0664L62.3463 35.3987L67.4431 30.2842C67.8952 29.8305 67.676 29.0537 67.0526 28.8956C63.8055 28.0913 60.2294 28.9574 57.6947 31.5009C55.7423 33.4601 54.8243 36.0449 54.8723 38.6227L60.4966 44.2666C61.0515 44.136 61.627 44.0672 62.1887 44.0672ZM55.071 49.7042L51.1867 45.8064L40.7464 56.2898C39.0338 58.0084 39.0338 60.7925 40.7464 62.511C42.459 64.2296 45.2335 64.2296 46.9462 62.511L55.4135 54.0144C54.8928 52.6464 54.7353 51.1546 55.071 49.7042ZM43.8497 61.0468C42.9454 61.0468 42.2056 60.3044 42.2056 59.397C42.2056 58.4827 42.9386 57.7471 43.8497 57.7471C44.7608 57.7471 45.4939 58.4827 45.4939 59.397C45.4939 60.3044 44.7608 61.0468 43.8497 61.0468Z",
    fill: "#DAD1CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "agenda_mobile_empty_day_clip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendaMobileEmptyDay);
export default __webpack_public_path__ + "static/media/agenda-mobile-empty-day.ac900ee2b081510eb0fe2504d36812b1.svg";
export { ForwardRef as ReactComponent };